import { signOut, useSession } from "next-auth/react";

import { Avatar } from "@mantine/core";
import { IconLogout } from "@tabler/icons-react";
import { MenuItem } from "../Navigation/MenuItem";
import { MenuItemProps } from "../Navigation/@types/NavigationTypes";

export const ProfileMenu = () => {
  const { data: session } = useSession();

  const submenu: Array<MenuItemProps> = [
    // {
    //   props: {
    //     title: "Perfil",
    //     path: "/profile/my-account",
    //     icon: (
    //       <Avatar radius="xl" size={30} src="" alt="Perfil">
    //         <span style={{ color: "white" }}>P</span>
    //       </Avatar>
    //     ),
    //   },
    // },
    {
      props: {
        title: "Logout",
        path: "/logout",
        icon: (
          <IconLogout
            onClick={() => {
              signOut({ callbackUrl: `${process.env.BASE_URL}/login` });
            }}
          />
        ),
      },
    },
  ];

  function getUserInitials() {
    if (session) {
      let arrName = session.name.split(" ");
      return `${arrName[0].split("")[0]}${
        arrName.length > 1 ? arrName[1].split("")[0] : ""
      }`;
    } else {
      return "--";
    }
  }

  return (
    <div key="000P2" className="profile-container">
      <MenuItem
        key="000P1"
        props={{
          title: session ? session.name.split(" ")[0] : "--",
          icon: (
            <Avatar radius="xl" size={30} alt="Profile Avatar">
              <span style={{ color: "white" }}>{getUserInitials()}</span>
            </Avatar>
          ),
          dropdown: true,
          submenu: submenu,
        }}
      />
    </div>
  );
};
